import { createSelector, createSlice } from "@reduxjs/toolkit";
import { DATE_TIME_FORMAT } from "../../../app/constants/common";
import { serverDate, serverToUi } from "../../../app/utils/utilityFunctions";

const attendanceSlice = createSlice({
  name: "employeeAttendance",
  initialState: {
    dateRange: [null, null],
    hoveredDay: null,
  },
  reducers: {
    setDateRange: (state, { payload: { start, end } }) => {
      state.dateRange = [start, end];
    },
    clearDateRange: (state) => {
      state.dateRange = [null, null];
    },
    setHoveredDay: (state, { payload }) => {
      state.hoveredDay = payload;
    },
  },
});

export const { setDateRange, clearDateRange, setHoveredDay } = attendanceSlice.actions;
export const selectAttendanceDateRange = (state) => state.employeeAttendance.dateRange;
export const selectHoveredDay = (state) => state.employeeAttendance.hoveredDay;
export const selectAttendanceDisplayDateLabel = createSelector(
  [selectAttendanceDateRange],
  (range) =>
    `${serverToUi(range[0], DATE_TIME_FORMAT.UI_DATE_FORMAT) || "No Min Date"} - ${serverToUi(range[1], DATE_TIME_FORMAT.UI_DATE_FORMAT) || "Present Date"}`
);
export const selectAttendanceDateRangeInDateFormat = createSelector([selectAttendanceDateRange], (range) => [
  serverDate(range[0]),
  serverDate(range[1]),
]);
export const selectHoveredDayInDateFormat = createSelector([selectHoveredDay], (day) => serverDate(day));

export default attendanceSlice.reducer;
